import React from "react";
import { useDispatch } from "react-redux";
import { setSearch } from "../../store/slices/documentTypeSlice.ts";

interface FilterDocumentTypesProps {
  onNewClick?: () => void;
}

const FilterDocumentTypes: React.FC<FilterDocumentTypesProps> = ({ onNewClick }) => {
  const dispatch = useDispatch();
  const [timer, setTimer] = React.useState<ReturnType<typeof setTimeout> | null>(null);
  const [searchInput, setSearchInput] = React.useState<string>("");

  const handleSearchChange = (e: React.ChangeEvent<HTMLInputElement>) => {
    const newValue = e.target.value;
    setSearchInput(newValue);
    if (timer) clearTimeout(timer);
    setTimer(
      setTimeout(() => {
        dispatch(setSearch(newValue));
        setTimer(null);
      }, 500)
    );
  };

  return (
    <div className="mb-2">
      <div className="input-group">
        <div className="flex-fill position-relative">
          <div className="input-group">
            <div
              className="input-group-text position-absolute top-0 bottom-0 bg-none border-0 start-0"
              style={{ zIndex: 10 }}
            >
              {timer ? (
                <i className="fa fa-spinner fa-spin"></i>
              ) : (
                <i className="fa fa-search opacity-5"></i>
              )}
            </div>
            <input
              type="text"
              className="form-control px-35px bg-light"
              placeholder="Buscar por nombre del tipo de documento..."
              value={searchInput}
              onChange={handleSearchChange}
              style={{ borderRadius: onNewClick ? "999px 0 0 999px" : "999px" }}
            />
          </div>
        </div>
        {onNewClick && (
          <button
            type="button"
            className="btn btn-primary"
            onClick={onNewClick}
            style={{ borderRadius: "0 999px 999px 0", paddingInline: "1.25rem" }}
          >
            <i className="fa fa-plus me-2"></i>
            Nuevo Documento
          </button>
        )}
      </div>
    </div>
  );
};

export default FilterDocumentTypes;
